<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.499"
      height="19.563"
      viewBox="0 0 21.499 19.563"
      class="scaling-svg"
    >
      <g transform="translate(-261.075 -315.937)">
        <g transform="translate(210.575 -25)">
          <g transform="translate(49 344)">
            <g transform="translate(1.5 1.5)">
              <path
                d="M14.25,15H.75A.751.751,0,0,1,0,14.25v-9a.749.749,0,0,1,.334-.624l6.75-4.5a.749.749,0,0,1,.832,0l6.75,4.5A.748.748,0,0,1,15,5.25v9A.751.751,0,0,1,14.25,15ZM1.5,6.651V13.5h12V6.651L7.916,10.374a.749.749,0,0,1-.832,0Zm6-5L2.1,5.25l5.4,3.6,5.4-3.6-5.4-3.6Z"
                fill="#534d69"
              />
            </g>
          </g>
          <g transform="translate(-115.887 -298.136)">
            <g transform="translate(173.887 639.073)">
              <path d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Z" transform="translate(0 0)" fill="#534d69" />
            </g>
          </g>
        </g>
        <g transform="translate(272.172 319.628)">
          <path
            d="M.71.374a.353.353,0,0,0-.7-.041,4.05,4.05,0,0,0,.463,2.1,2.744,2.744,0,0,0,1.076,1.1,2.744,2.744,0,0,0-1.076,1.1,4.05,4.05,0,0,0-.463,2.1.353.353,0,1,0,.7-.041,3.347,3.347,0,0,1,.376-1.718A2.039,2.039,0,0,1,2.828,3.883,2.039,2.039,0,0,1,4.571,4.966a3.347,3.347,0,0,1,.376,1.718.353.353,0,1,0,.7.041,4.05,4.05,0,0,0-.463-2.1,2.744,2.744,0,0,0-1.076-1.1,2.744,2.744,0,0,0,1.076-1.1,4.05,4.05,0,0,0,.462-2.1.353.353,0,1,0-.7.041,3.347,3.347,0,0,1-.376,1.718A2.039,2.039,0,0,1,2.828,3.175,2.039,2.039,0,0,1,1.086,2.092,3.347,3.347,0,0,1,.71.374Z"
            transform="translate(0.985 0)"
            fill="#fff"
          />
          <path
            d="M0,.353A.353.353,0,0,1,.353,0h4.94a.353.353,0,0,1,0,.706H.353A.353.353,0,0,1,0,.353Z"
            transform="translate(0.99 6.352)"
            fill="#fff"
          />
          <path
            d="M0,.353A.353.353,0,0,1,.353,0h4.94a.353.353,0,0,1,0,.706H.353A.353.353,0,0,1,0,.353Z"
            transform="translate(0.99 0)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DocumentsToAcceptIcon extends Vue {}
</script>

<style>
</style>
